import { Button } from '@kanda-libs/ks-design-library';

import RequestChangesModal from './RequestChangesModal';
// import RequestChangesModal from './RequestChangesModal';
import useRequestChanges from './useRequestChanges';

const RequestChangesButton: React.FunctionComponent = function () {
  const { isLoading, onClick } = useRequestChanges();
  return (
    <>
      <Button.Text
        id="request-changes"
        variant="outline"
        label={
          <p className="text-14-22-em text-neutral-800 -mx-6">
            Request Changes
          </p>
        }
        className="col-span-1 md:col-span-2 hover:bg-neutral-100"
        isLoading={isLoading}
        onClick={onClick}
      />
      <RequestChangesModal />
    </>
  );
};

export default RequestChangesButton;
